import { Offcanvas, Form, Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import "./Events.css";
import { Controller, set, useForm } from "react-hook-form";
import ReactQuill from "react-quill-new";
import { useEffect, useState, ChangeEvent, useRef } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HelperService from "../../utility/HelperService";
import MultiSelect from "../../components/MultiSelect/MultiSelect";
import { PlusSquareFill, DashSquareFill } from "react-bootstrap-icons";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import AddSpeaker from "../Speakers/AddSpeaker";
import { stat } from "fs";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import placholder from "../../assets/default-avatar.jpg";
import CommonQuill from "../../components/editor/CommonQuill";
import { XCircleFill } from "react-bootstrap-icons";

interface EventFormData {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

interface Speaker {
  full_name: string;
  company?: string;
  position?: string;
  image?: string;
}

type FormData = {
  title: string;
  start_date: Date | null;
  end_date: Date | null;
  booking_start_date: string | null;
  booking_end_date: Date | null;
  location: string; // Map Location (Google Places, optional)
  locationText: string; // Location (plain text, required for offline)
  latitude: number | null;
  longitude: number | null;
  description: string;
  eventType: string;
  tagId: string;
  price: string;
  contact: string;
  agenda_description: string; // ✅ Add this line
  agenda_file?: File | null;
  speakers?: any[];
  category?: any;
  slug?: string;
  meta_description?: string;
  keyword?: string;
  status: "PUBLISHED" | "UNPUBLISHED"; // ✅ ADD
  createdBy?: string;
};

const AddEvents = ({ show, handleClose, data }: EventFormData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    reset,
    setValue,
    clearErrors,
    control,
    watch,
  } = useForm<FormData>({
    mode: "onChange",
    defaultValues: {
      start_date: null,
      end_date: null,
      eventType: "OFFLINE",
      status: "PUBLISHED",
    },
  });

  const [activeTab, setActiveTab] = useState<
    "INFO" | "SPEAKER" | "AGENDA" | "COUPON" | "TICKETS"
  >("INFO");
  const [isLoading, setLoading] = useState(false);
  const [editorValue, setEditorValue] = useState("");
  const [agendaDescription, setAgendaDescription] = useState("");
  const [contactValue, setContactValue] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [agendaFile, setAgendaFile] = useState<File | null>(null);
  const [tagsList, setTagsList] = useState([]);
  const [speakersList, setSpeakersList] = useState<Speaker[]>([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedSpeakers, setSelectedSpeakers] = useState<Speaker[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<any | null>(null);
  const [fileError, setFileError] = useState<string>("");
  const [originalTickets, setOriginalTickets] = useState<any[]>([]);
  const [removeBanner, setRemoveBanner] = useState(false);
  const [removeThumbnail, setRemoveThumbnail] = useState(false);
  const bannerInputRef = useRef<HTMLInputElement | null>(null);
  const thumbnailInputRef = useRef<HTMLInputElement | null>(null);
  const [tickets, setTickets] = useState<any[]>([
    {
      ticketType: "INTERNAL",
      name: "",
      description: "",
      amount: "",
      currency: "",
      date: "",
      _id: "",
      status: "PUBLISHED",
    },
  ]);
  const [ticketType, setTicketType] = useState<"INTERNAL" | "EXTERNAL">("INTERNAL");
  const [originalExternalTicket, setOriginalExternalTicket] = useState<{
    link: string;
    price: string;
  } | null>(null);
  const [externalTicket, setExternalTicket] = useState({
    link: "",
    price: "",
  });

  const [eventSpeakers, setEventSpeakers] = useState<any[]>([]);
  const [showSpeakerModal, setShowSpeakerModal] = useState(false);
  const [editingSpeaker, setEditingSpeaker] = useState<Speaker | null>(null);
  const [editingSpeakerIndex, setEditingSpeakerIndex] = useState<number | null>(
    null,
  );

  const [couponText, setCouponText] = useState("");
  const [couponEmail, setCouponEmail] = useState("");
  const [couponEmailError, setCouponEmailError] = useState("");

  const [thumbnailFile, setThumbnailFile] = useState<File | null>(null);
  const [thumbnailError, setThumbnailError] = useState("");

  const [showAddSpeaker, setShowAddSpeaker] = useState(false);
  const quillRef = useRef<any>(null);
  const descriptionRef = useRef<any>(null);
  const agendaRef = useRef<any>(null);
  const contactRef = useRef<any>(null);
  const couponRef = useRef<any>(null);
  useEffect(() => {
    if (tickets.length > 0) {
      const amounts = tickets
        .filter((t) => t.status !== "DELETED")
        .map((t) => parseFloat(t.amount))
        .filter((a) => !isNaN(a));
      if (amounts.length > 0) {
        const minPrice = Math.min(...amounts);
        setValue("price", minPrice.toString());
      }
    }
  }, [tickets]);

  const eventType = watch("eventType");
  const startDate = watch("start_date");
  const endDate = watch("end_date");
  const [isInfoValid, setIsInfoValid] = useState(false);

  const [agendaError, setAgendaError] = useState("");
  const agendaInputRef = useRef<HTMLInputElement | null>(null);
  const [existingAgendaFile, setExistingAgendaFile] = useState<{
    fileUrl: string;
    fileName: string;
  } | null>(null);
  const [removeAgendaFile, setRemoveAgendaFile] = useState(false);

  const [customErrors, setCustomErrors] = useState<{
    description?: string;
    agenda?: string;
    contact?: string;
    speakers?: string;
    category?: string;
    agendaFile?: string;
    file?: string;
    thumbnailFile?: string;
  }>({});

  const [ticketErrors, setTicketErrors] = useState<any[]>([]);
  const [externalErrors, setExternalErrors] = useState<{
    link?: string;
    price?: string;
  }>({});

  const isQuillEmpty = (value?: string) => {
    if (!value) return true;

    // remove html tags, &nbsp; and spaces
    const text = value
      .replace(/<(.|\n)*?>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };

  const validateInfoTab = async () => {
    const valid = await trigger([
      "title",
      "slug",
      "start_date",
      "end_date",
      "tagId",
      "booking_start_date",
      "booking_end_date",
      "meta_description",
      "keyword",
      "location",
      "locationText",
    ]);

    const newErrors: any = {};

    if (isQuillEmpty(editorValue)) {
      newErrors.description = "Description is required";
    }

    // if (isQuillEmpty(agendaDescription)) {
    //   newErrors.agenda = "Agenda description is required";
    // }

    if (isQuillEmpty(contactValue)) {
      newErrors.contact = "Contact details are required";
    }

    // if (!selectedSpeakers || selectedSpeakers.length === 0) {
    //   newErrors.speakers = "Please select at least one speaker";
    // }

    // if (!selectedCategory) {
    //   newErrors.category = "Please select a category";
    // }

    if (!file && (!data?.bannerUrl || removeBanner)) {
      newErrors.file = "Event image is required";
    } else {
      setFileError("");
    }

    if (!thumbnailFile && (!data?.thumbnailUrl || removeThumbnail)) {
      newErrors.thumbnailFile = "Event thumbnailUrl is required";
    } else {
      setThumbnailError("");
    }

    // 🔴 Agenda File mandatory
    // if (!agendaFile && !data?.agenda?.fileUrl) {
    //   newErrors.agendaFile = "Agenda file is required";
    // } else {
    //   setAgendaError("");
    // }

    setCustomErrors(newErrors);

    if (Object.keys(newErrors).length > 0 || !valid) {
      setActiveTab("INFO");
      return false;
    }

    return true;
  };
  // ----------------------------------------------------------------
  //  LOAD INITIAL DATA
  // ----------------------------------------------------------------
  useEffect(() => {
    const storedUser = localStorage.getItem("UserData");
    const userData = data?.user || (storedUser ? JSON.parse(storedUser) : null);
    if (show) {
      setActiveTab("INFO");
      setCouponEmailError("");
      loadTags();
      loadSpeakers();
      loadCategories();
    }

    if (data) {
      reset({
        title: data.title,
        eventType: data.eventType,
        status: data.status || "PUBLISHED",
        latitude: data.latitude || null,
        longitude: data.longitude || null,
        meta_description: data.meta_description,
        keyword: data.keyword || null,
        start_date: data.start_date ? new Date(data.start_date) : null,
        end_date: data.end_date ? new Date(data.end_date) : null,
        booking_start_date: data.booking_start_date
          ? new Date(data.booking_start_date).toISOString()
          : "",
        booking_end_date: data.booking_end_date
          ? new Date(data.booking_end_date)
          : null,
        location: data.location,
        locationText: data.locationText || "",
        description: data.description,
        price: data.price?.toString() || "",
        contact: data.contact,
        agenda_description: data.agenda?.description || "",
        slug: data.slug || "",
        createdBy: data?.createdBy?.fullName || ""
      });

      if (data?.speakers && Array.isArray(data.speakers)) {
        setEventSpeakers(
          data.speakers.map((spk: any) => ({
            _id: spk._id,
            full_name: spk.full_name,
            position: spk.position,
            company: spk.company,
            image: spk.image,
          })),
        );
      } else {
        setEventSpeakers([]);
      }

      setEditorValue(data.description);
      setAgendaDescription(data.agenda?.description || "");
      setContactValue(data.contact);


      setCouponText(data?.getCouponCode?.text || "");
      setCouponEmail(data?.getCouponCode?.email || "");

      setAgendaFile(null);
      setRemoveAgendaFile(false);

      if (data?.agenda?.fileUrl) {
        setExistingAgendaFile({
          fileUrl: data.agenda.fileUrl,
          fileName: data.agenda.fileName || "Agenda File",
        });
      } else {
        setExistingAgendaFile(null);
      }

      if (data.speakers) setSelectedSpeakers(data.speakers);
      if (data.category) setSelectedCategory(data.category);
      if (data.tickets) {
        setTicketType("INTERNAL");
        const formattedTickets = data.tickets.map((t: any) => ({
          _id: t._id,
          name: t.name || "",
          description: t.description || "",
          currency: t.currency || "INR",
          amount: t.amount?.$numberDecimal ?? t.amount ?? "", // ✅ FIX
          date: t.date ? t.date : "",
          status: t.status || "PUBLISHED",
        }));

        setTickets(formattedTickets);
        setOriginalTickets(data.tickets);
      }

      if (data?.externalTicket) {
        setTicketType("EXTERNAL");
        const ext = {
          link: data.externalTicket.link || "",
          price: data.externalTicket.price || "",
        };
        setExternalTicket(ext);
        setOriginalExternalTicket(ext);
        setTickets([]);
        setExternalErrors({});
      } else {
        setTicketType("INTERNAL");
      }
      console.log("gg", data.ticekt);
    } else {
      reset({ createdBy: userData?.fullName || "" });
      setEditorValue("");
      setAgendaDescription("");
      setAgendaFile(null);
      setCouponText("");
      setCouponEmail("");
      setExistingAgendaFile(null);
      setFile(null);
      setContactValue("");
      setSelectedSpeakers([]);
      setEventSpeakers([]);
      setSelectedCategory(null);
      setTicketType("INTERNAL");
      setTickets([
        {
          name: "",
          description: "",
          amount: "",
          currency: "",
          date: "",
          status: "PUBLISHED",
        },
      ]);
      setExternalTicket({
        link: "",
        price: "",
      });
      setOriginalTickets([]);
      setOriginalExternalTicket(null);
    }
  }, [show]);
  useEffect(() => {
    if (data?.tagId && tagsList.length > 0) {
      const tagId =
        typeof data.tagId === "object" ? data.tagId._id : data.tagId;

      setValue("tagId", tagId);
    }
  }, [data, tagsList]);

  const handleSpeakerSave = (speaker: Speaker) => {
    setEventSpeakers((prev) => {
      // EDIT MODE
      if (editingSpeakerIndex !== null) {
        const copy = [...prev];
        copy[editingSpeakerIndex] = speaker;
        return copy;
      }

      // ADD MODE
      return [...prev, speaker];
    });

    setEditingSpeaker(null);
    setEditingSpeakerIndex(null);
  };

  const titleValue = watch("title");

  useEffect(() => {

    //Edit mode me slug ko kabhi change nahi karna
    if (data?._id) return;

    if (!titleValue) {
      setValue("slug", "");
      return;
    }

    // only auto-generate slug when adding new event
    if (!data?._id) {
      const slug = HelperService.generateSlug(titleValue);
      setValue("slug", slug);
    }
  }, [titleValue]);

  // ----------------------------------------------------------------
  //  API HELPERS
  // ----------------------------------------------------------------
  const loadTags = async () => {
    const res: any = await WebService.getAPI({ action: "tags/get-tags/EVENT" });
    setTagsList(res?.data || []);
  };

  const loadSpeakers = async () => {
    const res: any = await WebService.getAPI({ action: "speaker/list" });
    setSpeakersList(res?.data || []);
  };

  const loadCategories = async () => {
    const res: any = await WebService.getAPI({
      action: "categories/get-list/EVENT",
    });
    setCategoryList(res?.data || []);
  };
  const ALLOWED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];

  // ----------------------------------------------------------------
  //  HANDLE SUBMIT
  // ----------------------------------------------------------------
  // If coupon text is provided, email is mandatory and must be valid.
  // Returns true if the tab is valid; sets inline error + toast otherwise.
  const validateCouponTab = (): boolean => {
    if (isQuillEmpty(couponText)) {
      setCouponEmailError("");
      return true;
    }
    if (!couponEmail.trim()) {
      setCouponEmailError("Email is required when coupon text is provided");
      toast.error("Please enter coupon email");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(couponEmail.trim())) {
      setCouponEmailError("Please enter a valid email");
      toast.error("Please enter a valid coupon email");
      return false;
    }
    setCouponEmailError("");
    return true;
  };

  const onSubmit = async (request: FormData) => {
    const valid = await validateInfoTab();
    if (!valid) {
      toast.error("Please fill required fields");
      setActiveTab("INFO");
      return;
    }

    if (!validateCouponTab()) {
      setActiveTab("COUPON");
      return;
    }
    if (fileError) {
      toast.error(fileError);
      return;
    }
    console.log(editorValue, "***");
    console.log(agendaDescription, "777");
    console.log(contactValue, "&&&");
    if (!editorValue || !contactValue) {
      // toast.error("Please fill required fields");
      setActiveTab("INFO");
      return;
    }
    request.description = editorValue;
    request.agenda_description = agendaDescription ?? "";
    request.contact = contactValue;

    if (
      request.end_date &&
      request.start_date &&
      request.end_date < request.start_date
    ) {
      toast.error("End date cannot be before start date");
      return;
    }

    // auto update price based on lowest ticket
    const amounts = ticketType === "EXTERNAL" ? [parseFloat(externalTicket.price)] : tickets
      .filter((t) => t.status !== "DELETED")
      .map((t) => parseFloat(t.amount))
      .filter((a) => !isNaN(a));

    if (amounts.length > 0) {
      request.price = Math.min(...amounts).toString();
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("title", request.title);
    formData.append("eventType", request.eventType);
    formData.append("start_date", request.start_date?.toISOString() || "");
    formData.append("end_date", request.end_date?.toISOString() || "");
    if (request.booking_start_date) {
      // Use the exact date & time the admin picked in the calendar
      // (the picker has showTimeSelect). Do NOT overwrite with the
      // current system time — that was making the saved time "random".
      const bookingStartdate = new Date(
        request.booking_start_date,
      ).toISOString();
      formData.append("booking_start_date", bookingStartdate);
    }
    if (request.booking_end_date) {
      // Use the exact date & time the admin picked in the calendar
      // (the picker has showTimeSelect). Do NOT overwrite with the
      // current system time — that was making the saved time "random".
      const bookingEndDate = new Date(request.booking_end_date).toISOString();
      formData.append("booking_end_date", bookingEndDate);
    }
    formData.append("location", request.location);
    formData.append("locationText", request.locationText || "");
    formData.append("latitude", request.latitude?.toString() || "");
    formData.append("longitude", request.longitude?.toString() || "");

    const editorDescription = descriptionRef.current?.getEditor();
    const descriptionRefHtml = editorDescription?.root.innerHTML || "";
    formData.append("description", descriptionRefHtml);

    formData.append("tagId", request.tagId);
    formData.append("price", request.price);

    const editorContactRef = contactRef.current?.getEditor();
    const contactRefHtml = editorContactRef?.root.innerHTML || "";
    formData.append("contact", contactRefHtml);

    const editorAgendaRef = agendaRef.current?.getEditor();
    const agendaRefHtml = editorAgendaRef?.root.innerHTML || "";
    formData.append("agenda_description", agendaRefHtml);

    formData.append("meta_description", request.meta_description || "");
    formData.append("keyword", request.keyword || "");
    if (file) formData.append("banner", file);
    if (thumbnailFile) formData.append("thumbnail", thumbnailFile);
    if (agendaFile) formData.append("agendaFile", agendaFile);

    if (removeAgendaFile) {
      formData.append("removeAgendaFile", "true");
    }
    if (removeBanner) {
      formData.append("removeBanner", "true");
    }

    if (removeThumbnail) {
      formData.append("removeThumbnail", "true");
    }
    formData.append("speakers", JSON.stringify(eventSpeakers));
    const editorCouponRef = couponRef.current?.getEditor();
    const couponRefHtml = editorCouponRef?.root.innerHTML || "";
    formData.append(
      "getCouponCode",
      JSON.stringify({
        text: isQuillEmpty(couponRefHtml) ? "" : couponRefHtml,
        email: couponEmail,
      })
    );
    formData.append("category", JSON.stringify(selectedCategory));
    if (ticketType === "EXTERNAL") {
      formData.append("externalTicket", JSON.stringify(externalTicket));
      formData.append("tickets", JSON.stringify([]));
    } else {
      formData.append("tickets", JSON.stringify(tickets));
    }
    formData.append("ticketType", ticketType);
    formData.append("status", request.status);
    formData.append("slug", request.slug || "");
    console.log("formdata", formData);
    try {
      const res: any = data?._id
        ? await WebService.fileUploadPutAPI({
          action: `events/updateEvent/${data._id}`,
          body: formData,
        })
        : await WebService.fileUploadAPI({
          action: `events/addEvent`,
          body: formData,
        });

      // if (!data?._id) {
      const eventId = res?.data?._id;
      if (eventId) {
        await saveEventTickets(eventId);
      }
      // }
      toast.success(res.message);
      setLoading(false);
      // Clear the picked media files, otherwise the next event opened for
      // edit keeps showing this event's banner / thumbnail preview.
      resetAgendaStates();
      setFile(null);
      if (bannerInputRef.current) bannerInputRef.current.value = "";
      if (thumbnailInputRef.current) thumbnailInputRef.current.value = "";
      handleClose();
      reset();
    } catch (err: any) {
      toast.error(err.response?.data?.message || "Error saving");
      setLoading(false);
    }
  };

  const saveEventTickets = async (eventId: string) => {
    if (!tickets || tickets.length === 0) return;

    try {
      for (const t of tickets) {
        const payload = {
          eventId,
          name: t.name,
          description: t.description,
          amount: t.amount,
          currency: "INR",
          date: t.date ? new Date(t.date).toISOString() : null,
          externalLink: t.externalLink || "",
          status: t.status,
        };

        // ---------------------------
        // UPDATE TICKET (when _id exists)
        // ---------------------------
        if (t._id) {
          await WebService.putAPI({
            action: `event-ticket/edit/${t._id}`,
            body: payload,
          });
        }

        // ---------------------------
        // ADD NEW TICKET (when _id does NOT exist)
        // ---------------------------
        else {
          await WebService.postAPI({
            action: `event-ticket/add`,
            body: payload,
          });
        }
      }

      toast.success("Tickets saved successfully!");
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Failed to save tickets");
      console.error("Ticket API Error:", error);
    }
  };
  const createImageHandler = (editorRef: React.RefObject<any>) => {
    return () => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.click();

      input.onchange = async () => {
        const file = input.files?.[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("storage", "EVENTS");

        try {
          const res: any = await WebService.fileUploadAPI({
            action: "upload",
            body: formData,
          });

          const imageUrl = res?.data?.url;
          if (!imageUrl) return;

          const editor = editorRef.current.getEditor();
          const range = editor.getSelection(true);

          editor.insertEmbed(range.index, "image", imageUrl);
          editor.setSelection(range.index + 1);
        } catch {
          toast.error("Image upload failed");
        }
      };
    };
  };

  const validateTickets = () => {
    const errors: any[] = [];

    tickets.forEach((t, i) => {
      const err: any = {};

      if (t.status === "DELETED") {
        errors[i] = err;
        return;
      }

      if (!t.name?.trim()) err.name = "Ticket name is required";
      if (!t.amount || isNaN(Number(t.amount)))
        err.amount = "Valid amount required";
      if (!t.date) err.date = "Ticket date is required";

      errors[i] = err;
    });

    setTicketErrors(errors);

    return errors.every((e) => Object.keys(e).length === 0);
  };

  const validateExternalTicket = () => {
    const errors: any = {};

    if (!externalTicket.link.trim()) {
      errors.link = "External link is required";
    }

    if (!externalTicket.price || isNaN(Number(externalTicket.price))) {
      errors.price = "Valid price is required";
    }

    setExternalErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const getLatLngFromPlaceId = (placeId: string) => {
    const service = new google.maps.places.PlacesService(
      document.createElement("div"),
    );

    service.getDetails(
      {
        placeId,
        fields: ["geometry", "formatted_address"],
      },
      (place, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          place?.geometry?.location
        ) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          console.log("Latitude:", lat);
          console.log("Longitude:", lng);

          setValue("latitude", lat);
          setValue("longitude", lng);
        }
      },
    );
  };

  const tabStyle = (tab: string) => ({
    cursor: "pointer",
    fontWeight: activeTab === tab ? "600" : "400",
    color: activeTab === tab ? "#007bff" : "#555",
    borderBottom:
      activeTab === tab ? "2px solid #007bff" : "2px solid transparent",
  });

  const resetAgendaStates = () => {
    setAgendaFile(null);
    setExistingAgendaFile(null);
    setRemoveAgendaFile(false);
    setThumbnailFile(null);
    setThumbnailError("");
    setCustomErrors({});
    setRemoveBanner(false);
    setRemoveThumbnail(false);

    if (agendaInputRef.current) {
      agendaInputRef.current.value = "";
    }
  };

  // ----------------------------------------------------------------
  //  RENDER
  // ----------------------------------------------------------------
  return (
    <>
      <AddSpeaker
        show={showSpeakerModal}
        handleClose={() => setShowSpeakerModal(false)}
        data={editingSpeaker}
        onSuccess={handleSpeakerSave}
      />
      <Offcanvas
        show={show}
        onHide={() => {
          resetAgendaStates();
          setFile(null);       // banner clear
          setEditorValue("");
          setContactValue("");
          setAgendaDescription("");
          reset();
          handleClose();
          setRemoveBanner(false);
          setRemoveThumbnail(false);
          if (bannerInputRef.current) bannerInputRef.current.value = "";
          if (thumbnailInputRef.current) thumbnailInputRef.current.value = "";

        }}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{data ? "Edit Event" : "Add Event"}</Offcanvas.Title>
        </Offcanvas.Header>

        {/* TABS */}
        <div className="d-flex gap-4 px-3 pt-2 pb-1 border-bottom">
          <div style={tabStyle("INFO")} onClick={() => setActiveTab("INFO")}>
            Event Info
          </div>

          {/* SPEAKER TAB */}
          <div
            style={tabStyle("SPEAKER")}
            onClick={async () => {
              const valid = await validateInfoTab();
              if (!valid) {
                toast.error("Please fill required Event Info first");
                return;
              }
              setActiveTab("SPEAKER");
            }}
          >
            Speaker
          </div>

          <div
            style={tabStyle("AGENDA")}
            onClick={async () => {
              const valid = await validateInfoTab();
              if (!valid) {
                toast.error("Please fill required Event Info first");
                return;
              }
              setActiveTab("AGENDA");
            }}
          >
            Agenda
          </div>

          <div
            style={tabStyle("COUPON")}
            onClick={async () => {
              const valid = await validateInfoTab();

              if (!valid) {
                toast.error("Please fill required Event Info first");
                return;
              }

              setActiveTab("COUPON");
            }}
          >
            Get Coupon Code
          </div>

          <div
            style={tabStyle("TICKETS")}
            onClick={async () => {
              if (!data) {
                const valid = await validateInfoTab();
                if (!valid) {
                  toast.error("Please fill all required fields");
                  return;
                }
              }
              if (!validateCouponTab()) return;
              setActiveTab("TICKETS");
            }}
          >
            Configure Tickets
          </div>
        </div>

        <Offcanvas.Body>
          {/* TAB — EVENT INFO */}
          <div style={{ display: activeTab === "INFO" ? "block" : "none" }}>
            <>
              <Form>
                <Card className="p-3 bg-light my-3 position-relative">
                  <span
                    className="bg-white position-absolute rounded small"
                    style={{ top: "-12px", left: "12px", padding: "0 8px" }}
                  >
                    Main Content
                  </span>

                  <Form.Group className="mb-2" controlId="eventName">
                    <Form.Label className="label">
                      Event Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter event name"
                      {...register("title", {
                        required: "Event name is required",
                        onChange: () => clearErrors("title"),
                      })}
                    />
                    {errors.title && (
                      <div className="error-message">
                        {errors.title.message}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-2" controlId="eventSlug">
                    <Form.Label className="label">Event Slug <span className="text-danger">*</span></Form.Label>

                    <Form.Control
                      type="text"
                      placeholder="Slug is auto-generated"
                      {...register("slug", {
                        required: "Slug is required",
                      })}
                    // disabled={data?._id ? false : true}
                    // readOnly={data?._id ? false : true}
                    />
                    {errors.slug && (
                      <div className="error-message">{errors.slug.message}</div>
                    )}
                  </Form.Group>
                  {/* ✅ Start Date */}
                  {/* ✅ Start Date */}
                  <Form.Group
                    className="mb-2 position-relative"
                    controlId="eventStartDate"
                  >
                    <Form.Label className="label">
                      Start Date & Time <span className="text-danger">*</span>
                    </Form.Label>
                    <Controller
                      name="start_date"
                      control={control}
                      rules={{ required: "Start date is required" }}
                      render={({ field }) => (
                        <DatePicker
                          className="form-control"
                          selected={field.value}
                          onChange={(date) => {
                            field.onChange(date);
                            trigger("end_date"); // 👈 re-validate end date if start changes
                          }}
                          minDate={new Date()}
                          showTimeSelect
                          timeIntervals={15}
                          dateFormat="MMMM d, yyyy h:mm aa"
                          placeholderText="Select start date and time"
                          shouldCloseOnSelect
                        />
                      )}
                    />
                    {errors.start_date && (
                      <div className="error-message">
                        {errors.start_date.message}
                      </div>
                    )}
                  </Form.Group>

                  {/* ✅ End Date */}
                  <Form.Group
                    className="mb-2 position-relative"
                    controlId="eventEndDate"
                  >
                    <Form.Label className="label">
                      End Date & Time <span className="text-danger">*</span>
                    </Form.Label>
                    <Controller
                      name="end_date"
                      control={control}
                      rules={{
                        required: "End date is required",
                        validate: (value) => {
                          if (value && startDate && value < startDate) {
                            return "End date & time cannot be earlier than start date & time";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => {
                        const isSameDay =
                          startDate && field.value
                            ? startDate.toDateString() ===
                            field.value.toDateString()
                            : false;

                        // Only restrict times when same day
                        const minTime =
                          isSameDay && startDate
                            ? startDate
                            : new Date(new Date().setHours(0, 0, 0, 0));
                        const maxTime = new Date(
                          new Date().setHours(23, 59, 59, 999),
                        );

                        return (
                          <DatePicker
                            className="form-control"
                            selected={field.value}
                            onChange={(date) => {
                              field.onChange(date);
                              trigger("end_date"); // ✅ Revalidate when user selects an end date
                            }}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            placeholderText="Select end date and time"
                            minDate={startDate || undefined}
                            minTime={minTime}
                            maxTime={maxTime}
                          />
                        );
                      }}
                    />
                    {errors.end_date && (
                      <div className="error-message">
                        {errors.end_date.message}
                      </div>
                    )}
                  </Form.Group>
                  {/* Price */}
                  {/* <Form.Group className="mb-2" controlId="eventPrice">
                  <Form.Label className="label">
                    Price <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter price"
                    {...register("price", { required: "Price is required" })}
                    onKeyPress={(e: any) => HelperService.allowOnlyNumericValue(e)}
                  />
                  {errors.price && (
                    <div className="error-message">{errors.price.message}</div>
                  )}
                </Form.Group> */}
                  {/* Tags Dropdown */}
                  <Form.Group className="mb-2" controlId="eventTag">
                    <Form.Label className="label">
                      Tag <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      {...register("tagId", {
                        required: "Please select a tag",
                        onChange: () => clearErrors("tagId"),
                      })}
                      size="sm"
                    >
                      <option value="">Select Tag</option>
                      {tagsList.map((tag: { _id: string; name: string }) => (
                        <option key={tag._id} value={tag._id}>
                          {tag.name}
                        </option>
                      ))}
                    </Form.Select>

                    {errors.tagId && (
                      <div className="error-message">
                        {errors.tagId.message}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-2" controlId="eventType">
                    <Form.Label className="label">
                      Event Type <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      {...register("eventType", { required: true })}
                      onChange={(e) => {
                        const val = e.target.value;
                        setValue("eventType", e.target.value);
                        clearErrors("eventType");

                        if (val === "ONLINE") {
                          setValue("location", "");
                          setValue("locationText", "");
                          setValue("latitude", null);
                          setValue("longitude", null);
                          clearErrors("location");
                          clearErrors("locationText");
                        }
                      }}
                    >
                      <option value="OFFLINE">Offline</option>
                      <option value="ONLINE">Online</option>
                    </Form.Select>
                  </Form.Group>
                  {eventType === "OFFLINE" && (
                    <Form.Group className="mb-2" controlId="eventLocation">
                      <Form.Label className="label">
                        Map Location
                      </Form.Label>

                      <input type="hidden" {...register("location")} />
                      <input type="hidden" {...register("latitude")} />
                      <input type="hidden" {...register("longitude")} />

                      <GooglePlacesAutocomplete
                        apiKey="AIzaSyDJingmNS68UQkBeiOwkDGDP3u6L_kyJSY"
                        selectProps={{
                          value: watch("location")
                            ? {
                              label: watch("location"),
                              value: watch("location"),
                            }
                            : null,
                          onChange: async (val: any) => {
                            console.log("Selected place:", val);

                            if (!val) {
                              console.log("Google address cleared", val);
                              setValue("location", "");
                              setValue("latitude", null);
                              setValue("longitude", null);
                              trigger("location");
                              return;
                            }

                            const address = val?.label;
                            setValue("location", address);

                            const placeId = val.value.place_id;

                            getLatLngFromPlaceId(placeId);
                            clearErrors("location");
                            trigger("location");
                          },
                          placeholder: "Search location…",
                          isClearable: true,
                          className: "location-google-dropdown",
                        }}
                      />

                      {errors.location && (
                        <div className="error-message">
                          {errors.location.message}
                        </div>
                      )}
                    </Form.Group>
                  )}
                  {eventType === "OFFLINE" && (
                    <Form.Group className="mb-2" controlId="eventLocationText">
                      <Form.Label className="label">
                        Location <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter location"
                        {...register("locationText", {
                          validate: (value) =>
                            eventType === "OFFLINE" && !value?.trim()
                              ? "Location is required for offline events"
                              : true,
                        })}
                      />
                      {errors.locationText && (
                        <div className="error-message">
                          {errors.locationText.message}
                        </div>
                      )}
                    </Form.Group>
                  )}
                  <Form.Group className="mb-2" controlId="eventStatus">
                    <Form.Label className="label">
                      Status <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      {...register("status", {
                        required: "Status is required",
                      })}
                      size="sm"
                    >
                      <option value="PUBLISHED">Published</option>
                      <option value="UNPUBLISHED">Unpublished</option>
                    </Form.Select>

                    {errors.status && (
                      <div className="error-message">
                        {errors.status.message}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-2" controlId="eventDescription">
                    <Form.Label className="label">
                      Description <span className="text-danger">*</span>
                    </Form.Label>
                    <CommonQuill
                      ref={descriptionRef}
                      value={editorValue}
                      onChange={setEditorValue}
                      storage="EVENTS"
                      initialHtml={show && data?.description ? HelperService.normalizeResizeHtml(data.description) : undefined}
                      onClearError={() =>
                        setCustomErrors((p) => ({
                          ...p,
                          description: undefined,
                        }))
                      }
                    />
                    {customErrors.description && (
                      <div className="error-message">
                        {customErrors.description}
                      </div>
                    )}
                  </Form.Group>
                  {/* <Form.Label className="label">
                    Speaker <span className="text-danger">*</span>
                  </Form.Label>
                  <MultiSelect
                    value={selectedSpeakers}
                    onChange={(val) => {
                      setSelectedSpeakers(val);
                      setCustomErrors((prev) => ({ ...prev, speakers: undefined }));
                    }}
                    listData={speakersList} // 🟩 passing data from parent
                  />
                  {customErrors.speakers && (
                    <div className="error-message">{customErrors.speakers}</div>
                  )} */}
                  {/* Category Dropdown */}
                  {/* <Form.Group className="mb-2" controlId="eventCategory">
                    <Form.Label className="label">
                      Category <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Select
                      value={selectedCategory?._id || ""}
                      onChange={(e) => {
                        const selected = categoryList.find(
                          (cat: any) => cat._id === e.target.value,
                        );
                        setSelectedCategory(selected || null);
                        setCustomErrors((prev) => ({
                          ...prev,
                          category: undefined,
                        }));
                      }}
                      size="sm"
                    >
                      <option value="">Select Category</option>
                      {categoryList.map(
                        (category: { _id: string; name: string }) => (
                          <option key={category._id} value={category._id}>
                            {category.name}
                          </option>
                        ),
                      )}
                    </Form.Select>

                    {customErrors.category && (
                      <div className="error-message">
                        {customErrors.category}
                      </div>
                    )}
                  </Form.Group> */}
                  {/* <Form.Group className="mb-2" controlId="eventDescription">
                    <Form.Label className="label">
                      Agenda Description <span className="text-danger">*</span>
                    </Form.Label>
                    <ReactQuill
                      ref={agendaRef}
                      theme="snow"
                      value={agendaDescription}
                      onChange={(val) => {
                        setAgendaDescription(val);
                        setCustomErrors((prev) => ({ ...prev, agenda: undefined }));
                      }}
                      className="editor"
                      modules={{
                        toolbar: {
                          container: [
                            ["bold", "italic", "underline"],
                            [{ list: "ordered" }, { list: "bullet" }],
                            [{ indent: "-1" }, { indent: "+1" }],
                            [{ size: ["small", false, "large"] }],
                            [{ color: [] }, { background: [] }],
                            ["link", "image"],
                            ["clean"],
                          ],
                          handlers: {
                            image: createImageHandler(agendaRef),
                          },
                        },

                      }}
                    />
                    {customErrors.agenda && (
                      <div className="error-message">{customErrors.agenda}</div>
                    )}
                  </Form.Group> */}

                  <Form.Group className="mb-2" controlId="eventContact">
                    <Form.Label className="label">
                      Contact <span className="text-danger">*</span>
                    </Form.Label>

                    <CommonQuill
                      ref={contactRef}
                      value={contactValue}
                      onChange={setContactValue}
                      storage="EVENTS"
                      initialHtml={show && data?.contact ? HelperService.normalizeResizeHtml(data.contact) : undefined}
                      onClearError={() =>
                        setCustomErrors((p) => ({
                          ...p,
                          contact: undefined,
                        }))
                      }
                    />
                    {customErrors.contact && (
                      <div className="error-message">
                        {customErrors.contact}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group
                    className="mb-2 position-relative"
                    controlId="eventBookingStartDate"
                  >
                    <Form.Label className="label">
                      Booking Start Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Controller
                      name="booking_start_date"
                      control={control}
                      rules={{ required: "Booking StartDate is required" }}
                      render={({ field }) => (
                        <DatePicker
                          className="form-control"
                          selected={field.value ? new Date(field.value) : null}
                          onChange={(date) =>
                            field.onChange(date?.toISOString())
                          }
                          showTimeSelect
                          placeholderText="Select booking start date"
                          // minDate={startDate || new Date()} // 🔥 main logic
                          maxDate={endDate || undefined}
                          timeIntervals={15}
                          dateFormat="MMMM d, yyyy h:mm aa"
                          shouldCloseOnSelect
                        />
                      )}
                    />
                    {errors.booking_start_date && (
                      <div className="error-message">
                        {errors.booking_start_date.message}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group
                    className="mb-2 position-relative"
                    controlId="eventBookingEndDate"
                  >
                    <Form.Label className="label">
                      Booking End Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Controller
                      name="booking_end_date"
                      control={control}
                      rules={{ required: "Booking end date is required" }}
                      render={({ field }) => (
                        <DatePicker
                          className="form-control"
                          selected={field.value}
                          onChange={(date) => field.onChange(date)}
                          placeholderText="Select booking end date"
                          minDate={
                            new Date(watch("booking_start_date") || new Date())
                          } // 👈 not before booking start
                          maxDate={endDate || undefined} // 👈 not after event end
                          timeIntervals={15}
                          dateFormat="MMMM d, yyyy h:mm aa"
                          showTimeSelect
                        />
                      )}
                    />
                    {errors.booking_end_date && (
                      <div className="error-message">
                        {errors.booking_end_date.message}
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="mb-2" controlId="createdBy">
                    <Form.Label className="label">Created By</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("createdBy")}
                      value={watch("createdBy") || ""}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-2" controlId="eventImage">
                    <Form.Label className="label">
                      Event Banner <span className="text-danger">*</span>
                    </Form.Label>
                    <p
                      className="mt-1 text-primary"
                      style={{ fontSize: "13px" }}
                    >
                      Note: Please upload an image of size:{" "}
                      <strong>405 × 232 px</strong> in{" "}
                      <strong>.png, .jpeg, .jpg or .svg</strong> format.
                    </p>
                    <Form.Control
                      type="file"
                      ref={bannerInputRef}
                      accept=".png,.jpg,.jpeg,.svg"
                      className="custom-image-upload"
                      onChange={(e) => {
                        const input = e.target as HTMLInputElement;
                        const selectedFile = input.files?.[0];

                        console.log(selectedFile, ">>>");
                        if (!selectedFile) {
                          setFileError("Event image is required");
                          setFile(null);
                          return;
                        }

                        if (!ALLOWED_IMAGE_TYPES.includes(selectedFile.type)) {
                          setFileError(
                            "Image format not supported. Please upload PNG, JPG, JPEG or SVG. image",
                          );
                          // console.log(fileError)
                          //      toast.error(fileError);
                          setFile(null);
                          input.value = ""; // reset input
                          return;
                        }

                        setCustomErrors((prev) => ({
                          ...prev,
                          file: undefined,
                        }));

                        // ✅ valid
                        setFileError("");
                        setRemoveBanner(false);
                        setFile(selectedFile);
                      }}
                    />

                    {customErrors.file && (
                      <div className="error-message">{customErrors.file}</div>
                    )}
                  </Form.Group>
                  {/* EventBanner Preview */}
                  {file && (
                    <div className="mb-2 event-image position-relative">
                      <img
                        src={URL.createObjectURL(file)}
                        alt="Event"
                        style={{ maxWidth: "100%", maxHeight: 200, objectFit: "contain" }}
                      />
                      <XCircleFill
                        size={22}
                        color="red"
                        className="position-absolute cursor-pointer"
                        style={{ top: 8, right: 8 }}
                        onClick={() => {
                          setFile(null);
                          if (bannerInputRef.current) {
                            bannerInputRef.current.value = "";
                          }
                        }}
                      />
                    </div>
                  )}

                  {!file && data?.bannerUrl && !removeBanner && (
                    <div className="mb-2 event-image position-relative">
                      <img
                        src={data.bannerUrl}
                        alt="Event"
                        style={{ maxWidth: "100%", maxHeight: 200, objectFit: "contain" }}
                      />
                      <XCircleFill
                        size={22}
                        color="red"
                        className="position-absolute cursor-pointer"
                        style={{ top: 8, right: 8 }}
                        onClick={() => setRemoveBanner(true)}
                      />
                    </div>
                  )}


                  <Form.Group className="mb-2" controlId="eventThumbnail">
                    <Form.Label className="label">
                      Event Thumbnail <span className="text-danger">*</span>
                    </Form.Label>

                    <p className="mt-1 text-primary" style={{ fontSize: "13px" }}>
                      Note: Upload thumbnail image (example size: <strong>300 × 300 px</strong>)
                    </p>

                    <Form.Control
                      type="file"
                      ref={thumbnailInputRef}
                      accept=".png,.jpg,.jpeg,.svg"
                      onChange={(e) => {
                        const input = e.target as HTMLInputElement;
                        const selectedFile = input.files?.[0];

                        if (!selectedFile) {
                          setThumbnailError("Event thumbnail is required");
                          setThumbnailFile(null);
                          return;
                        }

                        if (!ALLOWED_IMAGE_TYPES.includes(selectedFile.type)) {
                          setThumbnailError("Thumbnail format not supported");
                          setThumbnailFile(null);
                          input.value = "";
                          return;
                        }

                        setCustomErrors((prev) => ({
                          ...prev,
                          thumbnailFile: undefined,
                        }));

                        setThumbnailError("");
                        setRemoveThumbnail(false);
                        setThumbnailFile(selectedFile);
                      }}
                    />

                    {customErrors.thumbnailFile && (
                      <div className="error-message">{customErrors.thumbnailFile}</div>
                    )}
                  </Form.Group>

                  {/* Thumbnail Preview */}
                  {(thumbnailFile || (!removeThumbnail && data?.thumbnailUrl)) && (
                    <div className="mb-2 event-image position-relative">
                      <img
                        src={
                          thumbnailFile
                            ? URL.createObjectURL(thumbnailFile)
                            : data?.thumbnailUrl
                        }
                        alt="Thumbnail"
                        style={{
                          maxWidth: "100%",
                          maxHeight: 200,
                          objectFit: "contain",
                        }}
                      />

                      <XCircleFill
                        size={22}
                        color="red"
                        className="position-absolute cursor-pointer"
                        style={{ top: 8, right: 8 }}
                        onClick={() => {
                          if (thumbnailFile) {
                            setThumbnailFile(null);
                            if (thumbnailInputRef.current) {
                              thumbnailInputRef.current.value = "";
                            }
                          } else if (data?.thumbnailUrl) {
                            setRemoveThumbnail(true);
                          }
                        }}
                      />
                    </div>
                  )}
                </Card>
                {/* <Card className="p-3 bg-light my-3 position-relative">
                  <span
                    className="bg-white position-absolute rounded small"
                    style={{ top: "-12px", left: "12px", padding: "0 8px" }}
                  >
                    Media
                  </span> */}
                {/* IMAGE */}

                {/* <Form.Group className="mb-2" controlId="eventAgendaFile">
                    <Form.Label className="label">
                      Agenda File <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept=".pdf,.doc,.docx,.ppt,.pptx"
                      onChange={(e) => {
                        const input = e.target as HTMLInputElement;
                        const file = input.files && input.files[0];
                        if (!file) {
                          setAgendaError("Agenda file is required");
                          setAgendaFile(null);
                          return;
                        }

                        setCustomErrors((prev) => ({ ...prev, agendaFile: undefined }));
                        setAgendaError(""); // ✅ remove error
                        setAgendaFile(file);
                      }}

                    />
                    {customErrors.agendaFile && (
                      <div className="error-message">{customErrors.agendaFile}</div>
                    )}
                  </Form.Group>
                  {data?.agenda?.fileUrl && (
                    <div className="mt-2">
                      <a
                        href={data.agenda.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#6813A5",
                          textDecoration: "underline",
                        }}
                      >
                        📎 {data.agenda.fileName || "View existing agenda file"}
                      </a>
                    </div>
                  )} */}
                {/* </Card> */}

                <Card className="p-3 bg-light my-3 position-relative">
                  <span
                    className="bg-white position-absolute rounded small"
                    style={{ top: "-12px", left: "12px", padding: "0 8px" }}
                  >
                    SEO
                  </span>
                  <Form.Label className="label">
                    Meta Description
                    <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Meta Description"
                    {...register("meta_description", {
                      required: "Meta description is required",
                    })}
                  />
                  {errors.meta_description && (
                    <div className="error-message">
                      {errors.meta_description.message}
                    </div>
                  )}
                  <Form.Group className="mb-2" controlId="eventName">
                    <Form.Label className="label">
                      keyword <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter keyword"
                      {...register("keyword", {
                        required: "keyword are required",
                      })}
                    />
                    {errors.keyword && (
                      <div className="error-message">
                        {errors.keyword.message}
                      </div>
                    )}
                  </Form.Group>
                </Card>
              </Form>
            </>
          </div>

          {activeTab === "SPEAKER" && (
            <Card className="p-3 bg-light">
              {/* HEADER */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6>Speakers</h6>

                <CustomButton
                  isLoading={false}
                  label="Add Speaker"
                  onClick={() => {
                    setEditingSpeaker(null);
                    setShowSpeakerModal(true);
                  }}
                />
              </div>

              {/* NO DATA */}
              {eventSpeakers.length === 0 && (
                <div className="text-muted text-center">No speakers added</div>
              )}

              {/* SPEAKER CARDS */}
              <div className="d-flex flex-wrap gap-3">
                {eventSpeakers.map((spk, index) => (
                  <div
                    key={spk._id}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("speakerIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const from = Number(
                        e.dataTransfer.getData("speakerIndex"),
                      );
                      if (from === index) return;

                      const updated = [...eventSpeakers];
                      const [moved] = updated.splice(from, 1);
                      updated.splice(index, 0, moved);
                      setEventSpeakers(updated);
                    }}
                    className="border rounded p-3 bg-white"
                    style={{ width: 220, cursor: "move" }}
                  >
                    {/* DRAG HANDLE */}
                    <div className="text-muted mb-1" title="Drag to reorder">
                      ☰
                    </div>

                    {/* IMAGE */}
                    {/* {spk.image && ( */}
                    <img
                      src={spk.image || placholder}
                      alt={spk.full_name}
                      style={{
                        width: "100%",
                        height: 140,
                        objectFit: "cover",
                        borderRadius: 6,
                      }}
                      className="mb-2"
                    />
                    {/* )} */}

                    <strong>{spk.full_name}</strong>
                    <div className="small">{spk.position}</div>
                    <div className="small text-muted">{spk.company}</div>

                    {/* ACTIONS */}
                    <div className="d-flex gap-2 mt-2">
                      <PencilFill
                        className="cursor-pointer"
                        onClick={() => {
                          setEditingSpeaker(spk);
                          setEditingSpeakerIndex(index);
                          setShowSpeakerModal(true);
                        }}
                      />

                      <TrashFill
                        color="#DC143C"
                        className="cursor-pointer"
                        onClick={() =>
                          setEventSpeakers((prev) =>
                            prev.filter((_, i) => i !== index),
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </Card>
          )}

          <div style={{ display: activeTab === "AGENDA" ? "block" : "none" }}>
            <Card className="p-3 bg-light">
              <h6 className="mb-3">Agenda (Optional)</h6>

              {/* AGENDA DESCRIPTION */}
              <Form.Group className="mb-3">
                <Form.Label className="label">Agenda Description</Form.Label>

                <CommonQuill
                  ref={agendaRef}
                  value={agendaDescription}
                  onChange={setAgendaDescription}
                  storage="EVENTS"
                  initialHtml={show && data?.agenda?.description ? HelperService.normalizeResizeHtml(data.agenda.description) : undefined}
                  onClearError={() =>
                    setCustomErrors((p) => ({
                      ...p,
                      agenda: undefined,
                    }))
                  }
                />
              </Form.Group>

              {/* AGENDA FILE */}
              <Form.Group className="mb-2" controlId="eventAgendaFile">
                <Form.Label className="label">Agenda File</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.doc,.docx,.ppt,.pptx"
                  ref={agendaInputRef}
                  onChange={(e) => {
                    const input = e.target as HTMLInputElement;
                    const file = input.files && input.files[0];
                    console.log(file, ">>>");
                    if (!file) {
                      // setAgendaError("Agenda file is required");
                      setAgendaFile(null);
                      return;
                    }

                    setCustomErrors((prev) => ({
                      ...prev,
                      agendaFile: undefined,
                    }));
                    setAgendaError(""); // ✅ remove error
                    setAgendaFile(file);

                    // If user selects new file, means no need to remove old file
                    setRemoveAgendaFile(false);
                  }}
                />

                {/* Show selected file name */}
                {agendaFile && (
                  <div className="mt-2 d-flex justify-content-between align-items-center border rounded p-2 bg-white">
                    <span className="small text-success">
                      📎 Selected: <b>{agendaFile.name}</b>
                    </span>

                    <XCircleFill
                      size={20}
                      color="red"
                      className="cursor-pointer"
                      title="Remove file"
                      onClick={() => {
                        setAgendaFile(null);

                        // clear input
                        if (agendaInputRef.current) {
                          agendaInputRef.current.value = "";
                        }
                      }}
                    />
                  </div>
                )}
                {customErrors.agendaFile && (
                  <div className="error-message">{customErrors.agendaFile}</div>
                )}
              </Form.Group>
              {!agendaFile && existingAgendaFile && !removeAgendaFile && (
                <div className="mt-2 d-flex justify-content-between align-items-center border rounded p-2 bg-white">
                  <a
                    href={existingAgendaFile.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#6813A5",
                      textDecoration: "underline",
                    }}
                  >
                    📎 {existingAgendaFile.fileName || "View existing agenda file"}
                  </a>

                  <XCircleFill
                    size={20}
                    color="red"
                    className="cursor-pointer"
                    title="Delete existing file"
                    onClick={() => {
                      setRemoveAgendaFile(true);
                      toast.success("Agenda file removed (will be deleted after save)");
                    }}
                  />
                </div>
              )}
            </Card>
          </div>

          <div style={{ display: activeTab === "COUPON" ? "block" : "none" }}>
            <Card className="p-3 bg-light">

              <h6 className="mb-3">Get Coupon Code (Optional)</h6>

              <Form.Group className="mb-3">
                <Form.Label>Text</Form.Label>

                <CommonQuill
                  ref={couponRef}
                  value={couponText}
                  onChange={(val: string) => {
                    setCouponText(val);
                    if (isQuillEmpty(val)) setCouponEmailError("");
                  }}
                  storage="EVENTS"
                  initialHtml={show && data?.getCouponCode?.text ? HelperService.normalizeResizeHtml(data.getCouponCode.text) : undefined}
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>
                  Email
                  {!isQuillEmpty(couponText) && <span className="text-danger"> *</span>}
                </Form.Label>

                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={couponEmail}
                  onChange={(e) => {
                    setCouponEmail(e.target.value);
                    if (e.target.value.trim()) setCouponEmailError("");
                  }}
                  isInvalid={!!couponEmailError}
                />
                {couponEmailError && (
                  <div className="error-message">{couponEmailError}</div>
                )}
              </Form.Group>

            </Card>
          </div>

          {/* TAB — TICKETS */}
          {activeTab === "TICKETS" && (
            <Card className="p-3">
              <h6 className="mb-3">Tickets</h6>

              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">
                  Ticket Type <span className="text-danger">*</span>
                </Form.Label>

                <Form.Select
                  value={ticketType}
                  onChange={(e) => {
                    const value = e.target.value as "INTERNAL" | "EXTERNAL";

                    // ================================
                    // SWITCH TO EXTERNAL
                    // ================================
                    if (value === "EXTERNAL") {
                      // backup internal tickets
                      if (tickets.length > 0) {
                        setOriginalTickets(tickets);
                      }

                      // restore external if exists
                      if (originalExternalTicket) {
                        setExternalTicket(originalExternalTicket);
                      } else {
                        setExternalTicket({ link: "", price: "" });
                      }

                      setTickets([]);
                      setTicketErrors([]);
                    }

                    // ================================
                    // SWITCH TO INTERNAL
                    // ================================
                    if (value === "INTERNAL") {
                      // backup external ticket
                      if (externalTicket.link || externalTicket.price) {
                        setOriginalExternalTicket(externalTicket);
                      }

                      setExternalTicket({ link: "", price: "" });
                      setExternalErrors({});

                      // restore internal tickets
                      if (originalTickets.length > 0) {
                        setTickets(originalTickets);
                      } else {
                        setTickets([
                          {
                            _id: "",
                            name: "",
                            description: "",
                            amount: "",
                            currency: "INR",
                            date: "",
                            status: "PUBLISHED",
                          },
                        ]);
                      }
                    }

                    setTicketType(value);
                  }}
                >
                  <option value="INTERNAL">Internal Ticket</option>
                  <option value="EXTERNAL">External Ticket</option>
                </Form.Select>
              </Form.Group>

              {ticketType === "INTERNAL" && (
                <>
                  {tickets.filter((t: any) => t.status !== "DELETED").map((ticket: any, i: number) => {
                    const actualIndex = tickets.indexOf(ticket);
                    return (
                      <Card key={actualIndex} className="p-3 mb-3 shadow-sm">
                        <div className="d-flex justify-content-between">
                          <h6>Ticket {i + 1}</h6>

                          <div>
                            <PlusSquareFill
                              className="text-success cursor-pointer me-2"
                              size={20}
                              onClick={() =>
                                setTickets([
                                  ...tickets,
                                  {
                                    _id: "",
                                    ticketType: "INTERNAL",
                                    name: "",
                                    description: "",
                                    amount: "",
                                    currency: "INR",
                                    date: "",
                                    status: "PUBLISHED",
                                    externalLink: "",
                                    externalPrice: "",
                                  },
                                ])
                              }
                            />

                            {tickets.filter((t: any) => t.status !== "DELETED").length > 1 && (
                              <DashSquareFill
                                className="text-danger cursor-pointer"
                                size={20}
                                onClick={() => {
                                  if (ticket._id) {
                                    const cl = [...tickets];
                                    cl[actualIndex].status = "DELETED";
                                    setTickets(cl);
                                  } else {
                                    setTickets(tickets.filter((_, idx) => idx !== actualIndex));
                                  }
                                }}
                              />
                            )}
                          </div>
                        </div>

                        <Form.Group className="mb-2">
                          <Form.Label>
                            Name <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={ticket.name}
                            onChange={(e) => {
                              const cl = [...tickets];
                              cl[actualIndex].name = e.target.value;
                              setTickets(cl);

                              setTicketErrors((prev) => {
                                const copy = [...prev];
                                if (copy[actualIndex]) copy[actualIndex].name = undefined;
                                return copy;
                              });
                            }}
                          />
                          {ticketErrors[actualIndex]?.name && (
                            <div className="error-message">
                              {ticketErrors[actualIndex].name}
                            </div>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-2">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            value={ticket.description}
                            onChange={(e) => {
                              const cl = [...tickets];
                              cl[actualIndex].description = e.target.value;
                              setTickets(cl);
                            }}
                          />
                        </Form.Group>

                        <Form.Group className="mb-2">
                          <Form.Label>
                            Amount (Zero is also valid for free)
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={ticket.amount}
                            onChange={(e) => {
                              const cl = [...tickets];
                              cl[actualIndex].amount = e.target.value;
                              setTickets(cl);

                              setTicketErrors((prev) => {
                                const copy = [...prev];
                                if (copy[actualIndex]) copy[actualIndex].amount = undefined;
                                return copy;
                              });
                            }}
                          />
                          {ticketErrors[actualIndex]?.amount && (
                            <div className="error-message">
                              {ticketErrors[actualIndex].amount}
                            </div>
                          )}
                        </Form.Group>

                        {/* <Form.Group className="mb-2">
                    <Form.Label>Currency</Form.Label>
                    <Form.Control
                      type="text"
                      value={ticket.currency}
                      onChange={(e) => {
                        const cl = [...tickets];
                        cl[i].currency = e.target.value;
                        setTickets(cl);
                      }}
                    />
                  </Form.Group> */}
                        <Form.Group className="mb-2">
                          <Form.Label>
                            Status <span className="text-danger">*</span>
                          </Form.Label>

                          <Form.Select
                            value={ticket.status}
                            onChange={(e) => {
                              const cl = [...tickets];
                              cl[actualIndex].status = e.target.value;
                              setTickets(cl);
                            }}
                          >
                            <option value="PUBLISHED">Published</option>
                            <option value="UNPUBLISHED">Unpublished</option>
                          </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-2 position-relative">
                          <Form.Label>
                            Ticket expiry date <span className="text-danger">*</span>
                          </Form.Label>
                          <DatePicker
                            className="form-control"
                            selected={ticket.date ? new Date(ticket.date) : null}
                            onChange={(date: Date | null) => {
                              const cl = [...tickets];
                              cl[actualIndex].date = date ? date.toISOString() : "";
                              setTickets(cl);

                              setTicketErrors((prev) => {
                                const copy = [...prev];
                                if (copy[actualIndex]) copy[actualIndex].date = undefined;
                                return copy;
                              });
                            }}
                            showTimeSelect
                            timeIntervals={15}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            placeholderText="Select ticket date & time"
                            // minDate={startDate || undefined}
                            // maxDate={endDate || undefined}
                            shouldCloseOnSelect
                          />

                          {ticketErrors[actualIndex]?.date && (
                            <div className="error-message">
                              {ticketErrors[actualIndex].date}
                            </div>
                          )}
                        </Form.Group>

                        {/* <Form.Group className="mb-2">
                    <Form.Label>External Link</Form.Label>
                    <Form.Control
                      type="url"
                      placeholder="https://example.com"
                      value={ticket.externalLink || ""}
                      onChange={(e) => {
                        const cl = [...tickets];
                        cl[i].externalLink = e.target.value;
                        setTickets(cl);
                      }}
                    />
                  </Form.Group> */}
                      </Card>
                    );
                  })}
                </>
              )}

              {ticketType === "EXTERNAL" && (
                <Card className="p-3">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      External Booking Link <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="url"
                      placeholder="https://example.com"
                      value={externalTicket.link}
                      onChange={(e) =>
                        setExternalTicket({ ...externalTicket, link: e.target.value })
                      }
                    />
                    {externalErrors.link && (
                      <div className="error-message">{externalErrors.link}</div>
                    )}
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>
                      Price <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={externalTicket.price}
                      onChange={(e) =>
                        setExternalTicket({ ...externalTicket, price: e.target.value })
                      }
                    />
                    {externalErrors.price && (
                      <div className="error-message">{externalErrors.price}</div>
                    )}
                  </Form.Group>
                </Card>
              )}
            </Card>
          )}
        </Offcanvas.Body>

        {/* FOOTER SAVE BUTTON */}
        <div className="d-flex justify-content-end p-3">
          {activeTab === "INFO" && (
            <CustomButton
              label="Next"
              className="w-100"
              isLoading={isLoading}
              onClick={async () => {
                const valid = await validateInfoTab();
                if (!valid) {
                  toast.error("Please fill all required fields");
                  return;
                }
                ///set description value from quill editor before moving to next tab
                // const editorDescription = descriptionRef.current?.getEditor();
                // const descriptionRefHtml = editorDescription?.root.innerHTML || "";
                // setEditorValue(descriptionRefHtml);

                // const editorContactRef = contactRef.current?.getEditor();
                // const contactRefHtml = editorContactRef?.root.innerHTML || "";
                // setContactValue(contactRefHtml);

                ///set description value from quill editor before moving to next tab

                setActiveTab("SPEAKER")
              }}
            />
          )}

          {activeTab === "SPEAKER" && (
            <CustomButton
              className="w-100"
              isLoading={isLoading}
              label="Next"
              onClick={() => setActiveTab("AGENDA")}
            />
          )}

          {activeTab === "AGENDA" && (
            <CustomButton
              className="w-100"
              isLoading={isLoading}
              label="Next"
              onClick={() => {
                ///set description value from quill editor before moving to next tab
                // const editorAgendaRef = agendaRef.current?.getEditor();
                // const agendaRefHtml = editorAgendaRef?.root.innerHTML || "";
                // setAgendaDescription(agendaRefHtml);
                ///set description value from quill editor before moving to next tab

                setActiveTab("COUPON")
              }}
            />
          )}

          {activeTab === "COUPON" && (
            <CustomButton
              className="w-100"
              isLoading={isLoading}
              label="Next"
              onClick={() => {
                if (!validateCouponTab()) return;
                setActiveTab("TICKETS");
              }}
            />
          )}

          {activeTab === "TICKETS" && (
            <CustomButton
              isLoading={isLoading}
              label="Save Event"
              className="w-100"
              onClick={handleSubmit((data) => {
                if (ticketType === "EXTERNAL") {
                  const valid = validateExternalTicket();
                  if (!valid) return;
                }

                if (ticketType === "INTERNAL") {
                  const ticketsValid = validateTickets();
                  if (!ticketsValid) return;
                }

                onSubmit(data);
              })}
            />
          )}
        </div>
      </Offcanvas>
    </>
  );
};

export default AddEvents;
